export default __webpack_public_path__ + "static/index-title-news-en-0ce14054f3292a75c0a826b0590085dc.png";